'use client';

import InteractiveFigure, { LabelConfig } from './InteractiveFigure';
import PulseLogicFig from '@/assets/PulseLogicFig';

const PULSELOGIC_LABELS: LabelConfig[] = [
  { id: 'a1', label: 'Solenoid valve', description: 'Turns water on and off to each zone.' },
  { id: 'a2', label: 'Irrigation pump', description: 'Pumps water to the irrigation zones.' },
  { id: 'a3', label: 'Fertilizer pump', description: 'Adds fertilizer to the dripline water supply.' },
  { id: 'a4', label: 'Fertilizer pump', description: 'Adds fertilizer to the dripline water supply.' },
  { id: 'a5', label: 'Irrigation controller', description: 'Controls the pumps and valves and communicates with the cloud.' },
  { id: 'a6', label: 'Soil water potential sensor', description: 'Buried at 45 cm, it shows moisture and temperature in the lower root zone.' },
  { id: 'a7', label: 'Soil water potential sensor', description: 'Buried at 30 cm, it shows moisture and temperature in the main root zone, which responds more slowly to changes in moisture.' },
  { id: 'a8', label: 'Soil water potential sensor', description: 'Buried at 15 cm, it shows moisture and temperature in the topsoil and responds quickly after rain or irrigation.' },
  { id: 'a9', label: 'EC & soil moisture sensor', description: 'Measures electrical conductivity (EC), soil moisture, and temperature in the root zone. Used for planning fertigation.' },
  { id: 'a10', label: 'Dripline pressure sensor', description: 'Confirms that the dripline is pressurized and can alert you to dripline breaks or solenoid issues.' },
  { id: 'a11', label: 'Node', description: 'Powers the sensors and sends data to the cloud.' },
  { id: 'a12', label: 'Weather station', description: 'Measures local wind, temperature, and precipitation to inform irrigation decisions.' },
];

export default function PulseLogicFigure() {
  return (
    <InteractiveFigure
      FigureComponent={PulseLogicFig}
      labels={PULSELOGIC_LABELS}
      minWidth={1200}
      centerOffset={0}
    />
  );
}
